import { render, staticRenderFns } from "./SwitchButtonLock.vue?vue&type=template&id=4dc0ce50&scoped=true&"
import script from "./SwitchButtonLock.vue?vue&type=script&lang=js&"
export * from "./SwitchButtonLock.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4dc0ce50",
  null
  
)

export default component.exports